import React, { useState } from "react";

type TextAreaProps = {
  show_label?: boolean;
  label?: string;
  rows?: number;
  name: string;
  placeholder?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  is_required?: boolean;
  error?: string;
  autoComplete?: string;
  className?: string;
  maxLength?: number;
};

const CommonTextArea: React.FC<TextAreaProps> = ({
  show_label = false,
  label = "",
  rows = 4,
  name,
  placeholder = "",
  value,
  onChange,
  is_required = false,
  error,
  autoComplete,
  className,
  maxLength,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const isNearLimit =
    maxLength !== undefined && value.length >= maxLength * 0.9;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-1 mt-5">
        {show_label && (
          <label
            htmlFor={name}
            className={`${is_required ? "required" : ""} fs-6 fw-semibold form-label mb-1`}
          >
            {label}
          </label>
        )}

        {maxLength !== undefined && (
          <div
            className={`text-xs mt-1 ml-1 text-right ${
              isNearLimit ? "text-red-500" : "text-gray-400"
            }`}
          >
            {value.length}/{maxLength}
          </div>
        )}
      </div>

      <textarea
        rows={rows}
        name={name}
        id={name}
        autoComplete={autoComplete}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={`form-control ${error ? "is-invalid" : ""} ${
          className ?? ""
        }`}
        placeholder={placeholder}
        value={value}
        required={is_required}
        maxLength={maxLength}
      />

      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};

export default CommonTextArea;
